import "../../App.css";

import error from "../../img/svg/question-circle.svg";

let today = new Date();
let dd = today.getDate();
let mm = today.getMonth() + 1;
const yyyy = today.getFullYear() - 14;
let minDate = new Date();
let ddmin = today.getDate();
let mmmin = today.getMonth() + 1;
const yyyymin = today.getFullYear() - 80;

if (ddmin < 10) {
  ddmin = "0" + ddmin;
}

if (mmmin < 10) {
  mmmin = "0" + mmmin;
}

if (dd < 10) {
  dd = "0" + dd;
}

if (mm < 10) {
  mm = "0" + mm;
}

const maxDate = yyyy + "-" + mm + "-" + dd;
minDate = yyyymin + "-" + mmmin + "-" + ddmin;

function Step2({
  setPage,
  page,
  nombre,
  setNombre,
  nombreAlert,
  setNombreAlert,
  apellido,
  setApellido,
  apellidoAlert,
  setApellidoAlert,
  fechaNac,
  setFechaNac,
  fechaNacAlert,
  setFechaNacAlert,
  telefono,
  setTelefono,
  telefonoAlert,
  setTelefonoAlert,
  region,
  setRegion,
  regionAlert,
  setRegionAlert,
  validation,
  termycond,
  setTyc,
  regiones,
}) {
  const isAllowedToPass = () => {
    if (validationPage2()) {
      setPage((currentPage) => currentPage + 1);
    }
  };

  const validationPage2 = () => {
    const fecha_nac = new Date(fechaNac);
    const max_date = new Date(maxDate);

    let isOk = true;

    if (nombre === "") {
      isOk = false;
      setNombreAlert("error_label");
    }

    if (apellido === "") {
      isOk = false;
      setApellidoAlert("error_label");
    }

    if (telefono === "" || telefono.length !== 9) {
      isOk = false;
      setTelefonoAlert("error_label");
    }

    if (region === "") {
      isOk = false;
      setRegionAlert("error_label");
    }

    if (fechaNac === "" || fecha_nac > max_date) {
      isOk = false;
      setFechaNacAlert("error_label");
    }

    if (termycond !== true) {
      isOk = false;
    }

    return isOk;
  };
  const getOptions = () => {
    return regiones.map((reg, i) => {
      return (
        <>
          <option key={i} value={reg.id_region}>
            {reg.nombre_region}
          </option>
        </>
      );
    });
  };
  return (
    <section class="step style--3">
      <div class="in">
        <header class="marquee">
          <div class="in">
            <div class="maxwidth">
              <div class="logo gone"></div>
              <div class="ttl">
                <span class="num fonty">{page + 1}</span>
                <h2>Tus datos</h2>
              </div>
              <div class="air gone"></div>
            </div>
          </div>
        </header>
        <main>
          <div class="maxwidth2">
            <div class="ttl text--center big steps-title titular">
              Cuéntanos{" "}
              <strong className="bold_letter">un poco más de ti</strong>
            </div>
          </div>
          <div class="maxwidth2">
            <div class="cols cols2">
              <div class="col col1">
                <div class="list">
                  <div class="field input">
                    <label>
                      <span class="name">
                        <span>Nombres</span>
                      </span>
                      <input
                        id="nombre"
                        value={nombre}
                        class={nombreAlert}
                        type="text"
                        placeholder="Ej: Juan Andrés"
                        name="nombre"
                        onChange={(e) => {
                          if (e.target.value.match("^[a-zA-Z ]*$") != null) {
                            setNombre(e.target.value);
                            setNombreAlert("required empty");
                          }
                        }}
                      />
                    </label>
                  </div>
                  <div class="field input">
                    <label>
                      <span class="name">
                        <span>Apellidos</span>
                      </span>
                      <input
                        id="apellido"
                        value={apellido}
                        class={apellidoAlert}
                        type="text"
                        placeholder="Ej: López Pérez"
                        name="apellido"
                        onChange={(e) => {
                          setApellido(
                            e.target.value.replace(/[^a-zA-Z\s\-]+/gi, "")
                          );
                          setApellidoAlert("required empty");
                        }}
                      />
                    </label>
                  </div>
                  <div class="field input">
                    <label>
                      <span class="name">
                        <span>Fecha nacimiento</span>
                      </span>
                      <input
                        id="fechaNac"
                        value={fechaNac}
                        class={fechaNacAlert}
                        type="date"
                        name="fechaNac"
                        max={maxDate}
                        min={minDate}
                        onChange={(e) => {
                          setFechaNac(e.target.value);
                          setFechaNacAlert("required empty");
                        }}
                        onBlur={(e) => {
                          setFechaNac(e.target.value);
                          setFechaNacAlert("required empty");
                        }}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div class="col col1">
                <div class="list">
                  <div class="field input">
                    <label>
                      <span class="name">
                        <span>Teléfono</span>
                      </span>
                      <div className="tel_wrap">
                        <div className="tel_code">
                          <span>+56</span>
                        </div>
                        <input
                          id="telefono"
                          class={telefonoAlert}
                          type="text"
                          placeholder="Ej: 123456789"
                          name="telefono"
                          value={telefono}
                          onChange={(e) => {
                            setTelefono(
                              e.target.value.replace(/[^0-9\-]+/gi, "")
                            );
                            setTelefonoAlert("required empty");
                          }}
                        />
                      </div>
                    </label>
                  </div>
                  <div class="field select">
                    <label>
                      <span class="name">
                        <span>Región colegio egreso</span>
                      </span>
                      <div data-help="Crédito con Aval del Estado, corresponde a un préstamo bancario que financia tus estudios de manera parcial o total, el cual debes comenzar a pagar en cuotas luego de terminar la Universidad.">
                        <select
                          id="region"
                          name="region"
                          class={regionAlert}
                          value={region}
                          onChange={(e) => {
                            setRegion(e.target.value);
                            setRegionAlert("required empty");
                          }}
                        >
                          <option value="">Selecciona</option>
                          {getOptions()}
                        </select>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="maxwidth2 text--center">
            <div class="field checkbox">
              <label class="woah--holder">
                <input
                  id="termYCond"
                  name="termYCond"
                  class="required empty no--woah"
                  type="checkbox"
                  checked={termycond}
                  onChange={() => setTyc((currentValue) => !currentValue)}
                />
                <span>
                  He leído y entiendo los{" "}
                  <a
                    target="_blank"
                    href="https://www.unab.cl/politicas-de-privacidad/"
                  >
                    Términos de privacidad y datos
                  </a>
                  .
                </span>
              </label>
            </div>
          </div>
          <div class="button submit">
            <button
              id="button_submit"
              name="button_submit"
              onClick={() => {
                isAllowedToPass();
              }}
            >
              Continuar &darr;
            </button>
          </div>
        </main>
      </div>
    </section>
  );
}

export default Step2;
